import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Star, ExternalLink, Quote } from 'lucide-react';
import { Button } from '../ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Latest platform reviews + "Laisser un avis Google" (button appears once the Google review link is set in Admin > Paramètres)
export const GoogleReviewsSection = () => {
  const [data, setData] = useState(null);
  const [reviewUrl, setReviewUrl] = useState('');

  useEffect(() => {
    axios.get(`${API}/seo/recent-reviews`).then((r) => setData(r.data)).catch(() => {});
    axios.get(`${API}/seo/settings`).then((r) => setReviewUrl(r.data.google_review_url || '')).catch(() => {});
  }, []);

  if (!data || (data.reviews.length === 0 && !reviewUrl)) return null;

  return (
    <section className="py-16 bg-white" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <p className="text-overline text-[#F59E0B] mb-2">Ils nous font confiance</p>
            <h2 className="font-heading font-bold text-3xl text-[#111827]">Avis des professionnels</h2>
            {data.count > 0 && (
              <p className="text-[#4B5563] mt-2 flex items-center gap-2" data-testid="reviews-average">
                <span className="flex">{[1, 2, 3, 4, 5].map((i) => <Star key={i} className={`w-4 h-4 ${i <= Math.round(data.average) ? 'text-[#F59E0B] fill-[#F59E0B]' : 'text-gray-300'}`} />)}</span>
                <strong>{data.average}/5</strong> sur {data.count} avis vérifiés entre professionnels
              </p>
            )}
          </div>
          {reviewUrl && (
            <Button asChild className="bg-[#1E3A8A] hover:bg-[#1E3A8A]/90" data-testid="google-review-btn">
              <a href={reviewUrl} target="_blank" rel="noopener noreferrer"><Star className="w-4 h-4 mr-2" /> Laisser un avis Google <ExternalLink className="w-3 h-3 ml-2" /></a>
            </Button>
          )}
        </div>
        {data.reviews.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {data.reviews.map((r, i) => (
              <div key={i} className="bg-[#F9FAFB] rounded-xl p-6 border border-[#1E3A8A]/5" data-testid={`review-card-${i}`}>
                <Quote className="w-6 h-6 text-[#F59E0B]/60 mb-2" />
                <p className="text-[#374151] text-sm leading-relaxed line-clamp-4">« {r.comment} »</p>
                <div className="mt-4 flex items-center justify-between">
                  <div className="text-xs text-[#6B7280]"><span className="font-semibold text-[#111827]">{r.reviewer_name}</span> à propos de {r.target_name ? <Link to="/contractors" className="underline">{r.target_name}</Link> : 'un partenaire'}</div>
                  <span className="flex">{[1, 2, 3, 4, 5].map((i2) => <Star key={i2} className={`w-3.5 h-3.5 ${i2 <= Math.round(r.overall) ? 'text-[#F59E0B] fill-[#F59E0B]' : 'text-gray-300'}`} />)}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
